// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__JszvA","breadcrumb":"Breadcrumbs_breadcrumb__dtmzq","breadcrumbActive":"Breadcrumbs_breadcrumbActive__fcdlf"};